var map = {
	"./angry.png": "./src/assets/pngs/smiley-faces/angry.png",
	"./awe.png": "./src/assets/pngs/smiley-faces/awe.png",
	"./ecstatic.png": "./src/assets/pngs/smiley-faces/ecstatic.png",
	"./happy.png": "./src/assets/pngs/smiley-faces/happy.png",
	"./indifferent.png": "./src/assets/pngs/smiley-faces/indifferent.png",
	"./sad.png": "./src/assets/pngs/smiley-faces/sad.png",
	"./unhappy.png": "./src/assets/pngs/smiley-faces/unhappy.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/pngs/smiley-faces sync recursive ^\\.\\/.*\\.png$";